export class PressureDropWeightChange {
    constructor({
        id= ``,
        prdDate= ``,
        locName= ``,
        locId= ``,
        shiftName= ``,
        furnaceNumber= ``,
        aDropTime= ``,
        aMaxWeight= ``,
        aMinWeight= ``,
        aDiff= ``,
        aTopTemp= ``,
        aBottomTemp= ``,
        bDropTime= ``,
        bMaxWeight= ``,
        bMinWeight= ``,
        bDiff= ``,
        bTopTemp= ``,
        bBottomTemp= ``,
        cDropTime= ``,
        cMaxWeight= ``,
        cMinWeight= ``,
        cDiff= ``,
        cTopTemp= ``,
        cBottomTemp= ``,
        alkalinity= ``,
    }={}){
        this.id = id;
        this.prdDate = prdDate;
        this.locName = locName;
        this.locId = locId;
        this.shiftName = shiftName;
        this.furnaceNumber = furnaceNumber;
        this.aDropTime = aDropTime;
        this.aMaxWeight = aMaxWeight;
        this.aMinWeight = aMinWeight;
        this.aDiff = aDiff;
        this.aTopTemp = aTopTemp;
        this.aBottomTemp = aBottomTemp;
        this.bDropTime = bDropTime;
        this.bMaxWeight = bMaxWeight;
        this.bMinWeight = bMinWeight;
        this.bDiff = bDiff;
        this.bTopTemp = bTopTemp;
        this.bBottomTemp = bBottomTemp;
        this.cDropTime = cDropTime;
        this.cMaxWeight = cMaxWeight;
        this.cMinWeight = cMinWeight;
        this.cDiff = cDiff;
        this.cTopTemp = cTopTemp;
        this.cBottomTemp = cBottomTemp;
        this.alkalinity = alkalinity;
    }
}

export function gridFields(){
    return Object.freeze([
        {
            key: 'prdDate',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          // uneditable: true,
          notInTable: true,
          // unlistable: true,
          // sortable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },
        {
            key: 'shiftName',
            label: 'lbl.shiftPlan.shiftName',
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"甲",text:"lbl.shift.A"},
                {value:"乙",text:"lbl.shift.B"},
                {value:"丙",text:"lbl.shift.C"}
              ]
            }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"1",text:"opt.furnaceNumber1"},
                {value:"2",text:"opt.furnaceNumber2"},
                {value:"3",text:"opt.furnaceNumber3"},
                {value:"4",text:"opt.furnaceNumber4"},
                {value:"5",text:"opt.furnaceNumber5"},
                {value:"6",text:"opt.furnaceNumber6"}
              ]
            }
        },
        {
            key: 'aDropTime',
            label: 'lbl.pdm.aDropTime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
            key: 'aMaxWeight',
            label: 'lbl.pdm.aMaxWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aMinWeight',
            label: 'lbl.pdm.aMinWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aDiff',
            label: 'lbl.pdm.aDiff',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aTopTemp',
            label: 'lbl.pdm.aTopTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aBottomTemp',
            label: 'lbl.pdm.aBottomTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bDropTime',
            label: 'lbl.pdm.bDropTime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
            key: 'bMaxWeight',
            label: 'lbl.pdm.bMaxWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bMinWeight',
            label: 'lbl.pdm.bMinWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bDiff',
            label: 'lbl.pdm.bDiff',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bTopTemp',
            label: 'lbl.pdm.bTopTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bBottomTemp',
            label: 'lbl.pdm.bBottomTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cDropTime',
            label: 'lbl.pdm.cDropTime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
            key: 'cMaxWeight',
            label: 'lbl.pdm.cMaxWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cMinWeight',
            label: 'lbl.pdm.cMinWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cDiff',
            label: 'lbl.pdm.cDiff',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cTopTemp',
            label: 'lbl.pdm.cTopTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cBottomTemp',
            label: 'lbl.pdm.cBottomTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'alkalinity',
            label: 'lbl.pdm.alkalinity',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new PressureDropWeightChange()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.shiftNameFilter',
    'filter.furnaceNumberFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'shiftNameFilter': "default",
    'furnaceNumberFilter':"default",
    'locNameFilter': "default",
};